import React, { useState, useContext, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setEmail } from '../pages/slices/globalDataSlicer';
// import LimitedAdvise from './LimitedAdvise';
import './EmailForm.css';
import { CsrfTokenContext } from '../CsrfTokenContext'; // Assuming you have this context set up
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';
import Spinner from './Spinner';

const EmailForm = () => {
  const [status, setStatus] = useState(null);
  const [recipient, setRecipient] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true); // State to track email validity
  const [spin, setSpin] = useState(false);

  const { wallet, email, isPremium } = useSelector(state => state.globalData);

  const csrfToken = useContext(CsrfTokenContext);

  const dispatch = useDispatch();

  const refreshTokenIfNeeded = useCallback(async () => {
    if (isTokenExpired()) {        
      await handleLogin();
    }    
  },[]);

  const htmlMessage = `

      <table align="center" style="margin: 0 auto; text-align: center; width: 100%;">
    <tr>
        <td>
            <img width="300px" style="padding: 30px;" src="https://res.cloudinary.com/dy6ipsqfo/image/upload/v1726268041/logo20_r2kdll.png" alt="Strategy Notification" />
        </td>
    </tr>
    <tr>
        <td>
            <div style="max-width: 600px; margin: 0 auto; font-family: Arial, sans-serif; line-height: 1.5; text-align: justify; font-size: 12pt; color: #000395;">
                <p>Hello Premium!</p>
                <p>First of all, thank you for your support! We’re always working to improve Crypto Proton, and your support is key to our growth, not just as a product, but as a community</p>
                <p>Crypto Proton was created for people like you, who see the potential in the Web 3 ecosystem and want to make the most of it. Let’s work together to create amazing opportunities for everyone!</p>
            </div>
        </td>
    </tr>    
    <tr>
        <td>           
            <placeholder0>
        </td>
    </tr>
    <tr>
        <td>
            <p style="color: #ff6b00;">Remember! The future is unknown, but the past helps guide our decisions.</p>
        </td>
    </tr>
</table> 
    `;

  const sendEmail = async (msg, subject, recipient) => {
    try {

      await refreshTokenIfNeeded();

      setSpin(true);
      setStatus('Sending email...');
                
      const response = await fetch(`/api/send_email`, {
        method: 'POST',
        // credentials: 'include',
        headers: {          
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken          
        },
        body: JSON.stringify({
          subject: subject,
          recipient: recipient,
          message: msg,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setStatus('An error occurred: ' + errorData.error);
        throw new Error(errorData.error);
      }

      setSpin(false);

      setStatus('Email sent successfully!');
    } catch (error) {
      setStatus('An error occurred: ' + error);
      console.error('Error sending email:', error);
      setSpin(false);
    }
  };

  const saveEmailDb = async () => {
    try {

      await refreshTokenIfNeeded();
      
        const response = await fetch(`/api/set_get_email?wallet=${wallet}&email=${recipient}`, {
            method: 'GET',
            // credentials: 'include',
            headers: {              
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken
            }
        });
        
        if (!response.ok) {            
            const errorData = await response.json();
                throw new Error(errorData.error);
        }
        const result = await response.json();
        dispatch(setEmail(result.email));
        setStatus("Email saved! Feel free to test it out to make sure everything’s working smoothly.");

    } catch (err) {
        console.error('Error fetching data:', err);
        setStatus('An error occurred: ' + err);
    }
  };

  const saveEmail = () => {
    if (isEmailValid) {      
      saveEmailDb();      
    } else {
      setStatus('Please enter a valid email address.');
    }
  };

  const handleSendEmail = () => {
    if (isEmailValid) {
      sendEmail(htmlMessage, 'Wellcome! - (Do Not Reply)', email);
    } else {
      setStatus('Please enter a valid email address.');
    }
  };

  const validateEmail = (emailEntry) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailEntry);
  };

  const handleEmailChange = (e) => {
    const emailEntry = e.target.value;    
    setRecipient(emailEntry);
    setIsEmailValid(validateEmail(emailEntry));
  };

  useEffect(()=>{

    setRecipient(email);

  },[email])

  return (
    <>
      {/* {!isPremium && (
        <>
          <div style={{ position: 'absolute', right: '8%' }}>
            <LimitedAdvise
              width="80px"
              height="20px"
              message="Limited"
              tooltipTitle="Why it's limited?"
              tooltipPhrases={["Notifications unavailable"]}
              tooltipPosition="left" // Options: top, down, left, right
              tooltipWidth="250px"
            />
          </div>
          <br />
          <br />
        </>
      )} */}
  
      <fieldset className="fieldset-ms">
        <legend className="legend-ms">Setting Email</legend>
        <div style={{width:'464px'}} className={`${!isPremium ? 'disable_test_email' : ''}`}>
          <div style={{ height: '100px', paddingTop:'15px' }}>
            <label htmlFor="email-input">Email address:</label>
            <input
              id="email-input"
              type="email"
              value={recipient}
              onChange={handleEmailChange}
              className={`styled-input ${!isEmailValid ? 'input-error' : ''}`}
              required
              placeholder="Enter recipient's email"
            />
            {!isEmailValid && recipient.length > 0 && (
              <p className="error-message">Please enter a valid email address.</p>
            )}
          </div>
          <div className="button_wrapper">
            <div
              className={`button_container button_save ${!isEmailValid ? 'disable_test_email' : ''}`}
              onClick={saveEmail}
            >
              <i className="bi bi-save-fill" style={{ marginRight: '5px' }}></i>
              Save Email
            </div>
            <div className={`button_container button_test_email ${!email || !isEmailValid ? 'disable_test_email' : ''}`}
              onClick={handleSendEmail}
              style={{ display: 'flex', alignItems: 'center', justifyContent:'center', padding: spin ? '5px 20px' : '10px 20px' }}  // Flexbox for horizontal and vertical alignment
            >              
              <i className="bi bi-envelope" style={{ marginRight: '5px' }}></i>
              <span style={{ marginRight: '5px' }}>Test my Email</span>
              {spin && (
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                  <Spinner size='20px' thick='5px' title="" color="white" />
                </div>
              )}
            </div>
          </div>
          {status && <p style={{marginTop:'5px', whiteSpace:'nowrap', display:'flex', justifyContent:'center'}}>{status}</p>}
        </div>
      </fieldset>
    </>
  );
};

export default EmailForm;